import { MenuEntryType } from "@hermes/api-model-shell";
import { MenuEntryItem } from "@hermes/states/menu";

const minHeight = "42px";

export const getCategoryMaxHeight = (menuEntry: MenuEntryItem): string => {
    let subSubMenuLength: number = 0;

    for (const subMenu of menuEntry.menuEntryList) {
        if (subMenu.type !== MenuEntryType.separatorMenuEntry) {
            subSubMenuLength = Math.max(
                subSubMenuLength,
                subMenu.menuEntryList.length,
            );
        }
    }

    if (subSubMenuLength === 0) {
        // MaxHeight = MinHeight
        return minHeight;
    }

    const liMargin: number = 8;
    const liHeight: number = 20 + liMargin;
    const spanHeight: number = 14;

    return `${spanHeight + liHeight * subSubMenuLength}px`;
};

export const getCategoryMinHeight = (menuEntry: MenuEntryItem): string => {
    let subMenuLength: number = 0;

    let hasItemInSubMenu: boolean = false;
    for (const subMenu of menuEntry.menuEntryList) {
        if (
            subMenu.type !== MenuEntryType.separatorMenuEntry &&
            subMenu.menuEntryList.length > 0
        ) {
            hasItemInSubMenu = true;
        }
    }

    if (hasItemInSubMenu) {
        // to avoid conflict with getCategoryMaxHeight
        return minHeight;
    }

    subMenuLength = Math.max(subMenuLength, menuEntry.menuEntryList.length);

    if (subMenuLength > 4) {
        // minHeightMax for categories with no subSubMenu, equivalent to 4 lvl2
        return "128px";
    }

    const liMargin: number = 24;
    const liHeight: number = 14;

    return `${liMargin * (subMenuLength - 1) + liHeight * subMenuLength}px`;
};
